var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.62035 17.9072C4.01781 18.208 4.50121 18.0898 5.08129 17.6709L9.45336 14.459L13.8362 17.6709C14.4055 18.0898 14.8889 18.208 15.2864 17.9072C15.6731 17.6172 15.7483 17.123 15.512 16.457L13.7825 11.3115L18.1975 8.14258C18.7776 7.74512 19.0246 7.30469 18.8635 6.83203C18.7131 6.38086 18.262 6.16602 17.553 6.16602H12.1389L10.4954 1.03125C10.2805 0.354492 9.9475 0 9.45336 0C8.96996 0 8.63695 0.354492 8.41137 1.03125L6.76781 6.16602H1.35375C0.644764 6.16602 0.204335 6.38086 0.0432019 6.83203C-0.107189 7.30469 0.139881 7.74512 0.709217 8.14258L5.12426 11.3115L3.39476 16.457C3.15844 17.123 3.23363 17.6172 3.62035 17.9072Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star_icon.7bb0b6d193560a66bd65bbb3a9f6bf26.svg";
export { ForwardRef as ReactComponent };